import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00B08D',
                secondary: '#b0bec5',
                neutral: '#333333',
                muted: '#333333',
                error: '#b71c1c',
            },
        },
    },
})